import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncIconGalleryPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/IconGalleryPage/IconGalleryPage'
    componentImport={async () => (await import('src/pages/dev/IconGalleryPage'))}
    {...props}
  />
);
